/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Ellipse, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Database(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Ellipse cx={128} cy={80} rx={88} ry={48} opacity={0.2} />
      <Ellipse
        cx={128}
        cy={80}
        rx={88}
        ry={48}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Path
        d="M40,80v48c0,26.50967,39.39894,48,88,48s88-21.49033,88-48V80"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Path
        d="M40,128v48c0,26.50967,39.39894,48,88,48s88-21.49033,88-48V128"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
    </Svg>
  );
}

export default Database;
